import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { useEffect, useState } from 'react';
import { useAsyncFn } from 'react-use';
import { isSingleOfferProductWithOffer } from '@uno/common-cms';
import { useSnackAsyncError } from 'libs/common/hooks';
import { getAffiliationProducts } from 'services/networking/affiliation';

/**
 * Handle affiliation block (type slideshow) states
 */
var useAffiliationBlockSlideshow = function useAffiliationBlockSlideshow(initialLinkData, lang, site) {
  var _useSnackAsyncError = useSnackAsyncError(),
      snackAsyncError = _useSnackAsyncError.snackAsyncError;

  var _useState = useState(undefined),
      selectedProducts = _useState[0],
      setSelectedProducts = _useState[1];

  var addSelectedProduct = function addSelectedProduct(product) {
    setSelectedProducts(function (currentState) {
      return [].concat(_toConsumableArray(currentState !== null && currentState !== void 0 ? currentState : []), [product]);
    });
  };

  var editSelectedProduct = function editSelectedProduct(productIndex, product) {
    if (selectedProducts === undefined || selectedProducts.length === 0) {
      return;
    }

    selectedProducts.splice(productIndex, 1, product);
    setSelectedProducts(selectedProducts);
  };

  var removeSelectedProduct = function removeSelectedProduct(productIndex) {
    if (selectedProducts === undefined || selectedProducts.length === 0) {
      return;
    }

    setSelectedProducts(selectedProducts.filter(function (selectedProduct, index) {
      return index !== productIndex;
    }));
  };

  var _useAsyncFn = useAsyncFn( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(affiliationId) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return snackAsyncError({
                messageId: 'affiliation.error.get-products',
                callback: function () {
                  var _callback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var _yield$getAffiliation, products;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return getAffiliationProducts(lang, affiliationId, site);

                          case 2:
                            _yield$getAffiliation = _context.sent;
                            products = _yield$getAffiliation.products;
                            setSelectedProducts(products.filter(function (product) {
                              return isSingleOfferProductWithOffer(product);
                            }));

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  function callback() {
                    return _callback.apply(this, arguments);
                  }

                  return callback;
                }()
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }()),
      _useAsyncFn2 = _slicedToArray(_useAsyncFn, 2),
      retrieveProductsLoading = _useAsyncFn2[0].loading,
      retrieveProducts = _useAsyncFn2[1];

  useEffect(function () {
    if ((initialLinkData === null || initialLinkData === void 0 ? void 0 : initialLinkData.affiliationId) === undefined) {
      return;
    }

    void retrieveProducts(initialLinkData.affiliationId);
  }, [initialLinkData, retrieveProducts]);
  return {
    selectedProducts: selectedProducts,
    addSelectedProduct: addSelectedProduct,
    editSelectedProduct: editSelectedProduct,
    removeSelectedProduct: removeSelectedProduct,
    retrieveProductsLoading: retrieveProductsLoading
  };
};

export default useAffiliationBlockSlideshow;